import { Link } from 'react-router-dom';
import type { GlobalProps, ModulSeiteProps } from '../../core/modul';
import { Karte as KarteRahmen, Laden, Meldung } from '../../core/ui';
import { SEITE, sortieren, useAlleIdeen, useSitzungen } from './daten';
import { Zeichen } from './Text';
import './stil.css';

/** Karte auf der Projektübersicht: Ideen der Unterreiter, die diesem Projekt zugeordnet sind. */
export function Karte({ projekt, darfSchreiben }: ModulSeiteProps) {
  const { ideen, fehler } = useAlleIdeen(projekt.id);
  const fest = sortieren((ideen ?? []).filter((i) => i.status === 'festgehalten'), 'stimmen');
  const neu = (ideen ?? []).filter((i) => i.status === 'neu').length;
  const runden = new Set((ideen ?? []).map((i) => i.sitzungId)).size;

  return (
    <KarteRahmen titel={<Link to={SEITE}>Ideen</Link>} className="id-karte">
      <Meldung>{fehler}</Meldung>
      {!ideen ? (
        <Laden />
      ) : (
        <>
          <div className="id-karte-zahlen">
            <span>
              <strong>{fest.length}</strong> festgehalten
            </span>
            <span>
              <strong>{neu}</strong> neu
            </span>
            <span>
              <strong>{runden}</strong> {runden === 1 ? 'Runde' : 'Runden'}
            </span>
          </div>
          {fest.length === 0 ? (
            <p className="leise klein">Noch keine festgehaltenen Ideen für dieses Projekt.</p>
          ) : (
            <IdeenListe ideen={fest.slice(0, 5)} />
          )}
          {darfSchreiben && !projekt.archiviert && (
            <div className="reihe id-karte-knoepfe">
              <Link className="knopf knopf-klein" to={`${SEITE}?neu=ideen&projekt=${projekt.id}`}>
                + Ideen-Runde für das Projekt
              </Link>
            </div>
          )}
        </>
      )}
    </KarteRahmen>
  );
}

function IdeenListe({ ideen }: { ideen: { id: string; titel: string; sitzungId: string; punkte: number; projektName?: string | null }[] }) {
  return (
    <ul className="id-karte-liste">
      {ideen.map((i) => (
        <li key={i.id}>
          <Link to={`${SEITE}/${i.sitzungId}`}>{i.titel}</Link>
          {i.punkte !== 0 && (
            <span className="leise klein id-karte-punkte">
              {Zeichen.hoch} {i.punkte > 0 ? `+${i.punkte}` : i.punkte}
            </span>
          )}
        </li>
      ))}
    </ul>
  );
}

/** Karte auf der Startseite: offene Unterreiter und die besten festgehaltenen Ideen über alles, was ich sehen darf. */
export function Startkarte(_p: GlobalProps) {
  const { ideen, fehler } = useAlleIdeen();
  const { liste } = useSitzungen();
  const offen = (liste ?? []).filter((s) => !s.geschlossen);
  const fest = sortieren((ideen ?? []).filter((i) => i.status === 'festgehalten'), 'neu').slice(0, 5);
  return (
    <KarteRahmen titel={<Link to={SEITE}>Ideen</Link>} className="id-karte">
      <Meldung>{fehler}</Meldung>
      {!ideen || !liste ? (
        <Laden />
      ) : offen.length === 0 && !ideen.length ? (
        <p className="leise klein">
          Noch keine Ideen. <Link to={`${SEITE}?neu=ideen`}>Ideen-Runde starten</Link>
        </p>
      ) : (
        <>
          {offen.length > 0 && (
            <div className="id-start-reiter">
              {offen.slice(0, 4).map((s) => (
                <Link key={s.id} to={`${SEITE}/${s.id}`} className="id-marke">
                  {s.art === 'suche' ? Zeichen.lupe : Zeichen.stern} {s.titel}
                </Link>
              ))}
            </div>
          )}
          {fest.length ? <IdeenListe ideen={fest} /> : <p className="leise klein">Noch keine festgehaltenen Ideen.</p>}
        </>
      )}
    </KarteRahmen>
  );
}
